import React, { useEffect, useRef, useState } from "react";
import {
  Edit2,
  Trash2,
  CheckCircle2,
  XCircle,
  Search,
  Plus,
  Filter,
  Download,
  Eye,
} from "lucide-react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import axios from "axios";
import {
  activeExam,
  deleteExam,
  getExams,
  getExamsAdmin,
  insertOrUpdateExam,
} from "../../services/ExamService";
import UploadService from "../../services/UploadService";
import { HOSTNAME } from "../../common/apiClient";
import ExamForm from "./ExamForm";
import { Tooltip } from "@mui/material";
import DeleteConfirmModal from "../common/DeleteConfirmModal";
import {
  extractQuestionRange,
  getAllAnswerDS,
  getAllAnswerMA,
  getAllAnswerTN,
  isLineAnswerDS,
  isLineAnswerDSStartWith,
  isLineAnswerKT,
  isLineAnswerMA,
  isLineAnswerMAStartWith,
  isLineAnswerMQStartWith,
  isLineAnswerTN,
  isLineAnswerTNStartWith,
  isLineQuestionAnswer,
  isLineQuestionAnswerStartWith,
  isLineQuestionMQ,
  isNumeric,
  regexQuestionAnswer,
  removeHTMLTags,
  toLowerCaseNonAccentVietnamese,
} from "../../common/Utils";
import mammoth from "mammoth";
import { v4 as uuidv4 } from "uuid";

const configDate = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
  timeZone: "Asia/Ho_Chi_Minh",
};

export default function Exams() {
  const [formQuestionData, setFormData] = useState({
    title: "",
    url: "",
    numberOfQuestions: null,
    time: null,
    startTime: dayjs(new Date()),
    endTime: dayjs(new Date()),
    subject: "TƯ DUY TOÁN HỌC",
    type: "TSA",
    imgUrl: "",
    access: "PRIVATE",
    isAnswer: false,
  });

  const refs = {
    inputRef: useRef(null),
    inputRefQuestion: useRef(null),
    imageRefQuestion: useRef(null),
    imageRefAnswerQuestion: useRef(null),
    imageRefExam: useRef(null),
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 6;
  const [isEditing, setIsEditing] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [openDialogQuestion, setOpenDialogQuestion] = useState(false);
  const [openDialogExam, setOpenDialogExam] = useState(false);
  const [listExams, setListExams] = useState([]);
  const [answer, setAnswer] = useState({});
  console.log("🚀 ~ Exams ~ Answer:", answer);
  const [listKeys, setListKeys] = useState([]);
  const [question, setQuestion] = useState({
    question: "Câu 1",
    contentQuestions: "",
    imageUrl: "",
    explanation: "",
    type: "",
  });
  const [questionsData, setQuestionsData] = useState([]);
  const [errors, setErrors] = useState({
    title: false,
    url: false,
    numberOfQuestions: false,
    time: false,
    startTime: false,
    endTime: false,
  });
  const examsPerPage = 5;
  const indexOfLastExam = currentPage * examsPerPage;
  const indexOfFirstExam = indexOfLastExam - examsPerPage;
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    examId: null,
    examTitle: "",
  });

  const handleDeleteExam = (id, title) => {
    setDeleteModal({
      isOpen: true,
      examId: id,
      examTitle: title || "đề thi này",
    });
  };

  const confirmDeleteExam = async () => {
    try {
      const res = await deleteExam(deleteModal.examId);
      toast.success(res?.message);
      setListExams(
        listExams.filter((exam) => exam?._id !== deleteModal.examId)
      );
      setDeleteModal({ isOpen: false, examId: null, examTitle: "" });
      handleFetch();
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
      setDeleteModal({ isOpen: false, examId: null, examTitle: "" });
    }
  };

  const upLoadImageQuestions = async (event) => {
    try {
      const file = event.target?.files[0];
      if (file) {
        // Validate file type
        if (!file.type.startsWith("image/")) {
          toast.error("Chỉ cho phép upload file ảnh!");
          return;
        }

        // Validate file size (5MB)
        if (file.size > 5 * 1024 * 1024) {
          toast.error("File quá lớn! Kích thước tối đa là 5MB.");
          return;
        }

        // Chuyển đổi ảnh sang base64
        const reader = new FileReader();

        reader.onload = (e) => {
          const base64Image = e.target.result;

          console.log("upLoadImageQuestions ~ base64Image created");
          setQuestion({
            ...question,
            imageUrl: base64Image,
          });

          const ques = questionsData.find(
            (e) => e.question === question.question
          );
          if (ques) {
            ques.imageUrl = base64Image;
          }

          toast.success("Tải ảnh lên thành công (base64)");
          refs.imageRefQuestion.current.value = null;
        };

        reader.onerror = (error) => {
          console.error("Error reading file:", error);
          toast.error("Lỗi khi đọc file ảnh");
        };

        reader.readAsDataURL(file);
      }
    } catch (error) {
      console.error("Upload error:", error);
      const message = error?.message || "Lỗi khi tải ảnh lên";
      toast.error(message);
    }
  };

  const upLoadImageExam = async (event) => {
    try {
      const file = event.target?.files[0];
      if (file) {
        const response = await UploadService.uploadImage(file);
        if (response && response.data && response.data.imageUrl) {
          const imageUrl = `${HOSTNAME}${response.data.imageUrl}`;
          console.log("🚀 ~ upLoadImageExam ~ imageUrl:", imageUrl);
          setFormData({
            ...formQuestionData,
            imgUrl: imageUrl,
          });
          toast.success("Tải ảnh lên thành công");
          refs.imageRefExam.current.value = null;
        }
      }
    } catch (error) {
      console.error("Upload error:", error);
      const errorMessage =
        error?.response?.data?.message || "Tải ảnh lên thất bại";
      toast.error(errorMessage);
    }
  };

  const setDataInputQuestion = (key, parsedData) => {
    if (parsedData.length > 0) {
      const tempObjectQuestion = parsedData.find((e) => key == e["question"]);
      if (tempObjectQuestion) {
        setQuestion(tempObjectQuestion);
      }
      return;
    }
    setQuestion({
      question: key,
      contentQuestions: "",
      imageUrl: "",
      explanation: "",
    });
  };

  const handleFetch = async () => {
    try {
      const response = await getExamsAdmin(currentPage, limit, searchQuery);
      setListExams(response?.data);
      setTotalPages(response?.totalPages);
      setCurrentPage(response?.currentPage);
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  useEffect(() => {
    handleFetch();
  }, [currentPage]);

  // Copy the processQuestionsFromDocxMath function from Exams.js
  async function processQuestionsFromDocx(file) {
    try {
      // Store uploaded images URLs
      const uploadedImages = new Map();
      // Store temporary image data for conditional upload
      const tempImageData = new Map();

      // Đọc file .docx và chuyển đổi sang HTML với định dạng
      const arrayBuffer = await file.arrayBuffer();
      const result = await mammoth.convertToHtml(
        { arrayBuffer },
        {
          styleMap: [
            // Giữ nguyên định dạng bold, italic, underline
            "b => strong",
            "i => em",
            "u => u",
            // Thêm các định dạng khác
            "strike => del", // Gạch ngang
            "sub => sub", // Subscript
            "sup => sup", // Superscript
            // Color formatting
            "p[style-name='Heading 1'] => h1",
            "p[style-name='Heading 2'] => h2",
            "p[style-name='Heading 3'] => h3",
            // List formatting - cải thiện
            "p[style-name='List Paragraph'] => li",
            "p[style-name='ListParagraph'] => li",
            "p[style-name='Bullet List'] => li",
            "p[style-name='BulletList'] => li",
            // Font colors và highlights
            "r[style-name='Red Text'] => span.text-red",
            "r[style-name='Blue Text'] => span.text-blue",
            "r[style-name='Green Text'] => span.text-green",
            "r[style-name='Highlight'] => mark",
            // Table styles
            "table => table.word-table",
            "tr => tr.word-table-row",
            "td => td.word-table-cell",
            "th => th.word-table-header",
            "tbody => tbody.word-table-body",
            "thead => thead.word-table-head",
            // Có thể thêm các style mapping khác nếu cần
          ],
          // Thêm options để preserve formatting tốt hơn
          includeDefaultStyleMap: true,
          includeEmbeddedStyleMap: true,
          // Convert functions cho images - tạm thời chỉ tạo base64 cho validation
          convertImage: mammoth.images.imgElement(async function (image) {
            try {
              console.log(
                "Processing image from Word document for validation..."
              );

              // Read image as buffer
              const imageBuffer = await image.read();

              // Tạo unique key cho image
              const imageKey = `temp-image-${Date.now()}-${Math.random()
                .toString(36)
                .substr(2, 9)}`;

              // Lưu thông tin image để upload sau nếu validation thành công
              tempImageData.set(imageKey, {
                buffer: imageBuffer,
                contentType: image.contentType,
                altText: image.altText || "Image from Word document",
                originalName: `word-image-${Date.now()}.${
                  image.contentType.split("/")[1]
                }`,
              });

              // Tạo base64 tạm thời cho việc validation và hiển thị
              const base64 = `data:${image.contentType};base64,${Buffer.from(
                imageBuffer
              ).toString("base64")}`;

              console.log("Image processed for validation. Key:", imageKey);

              return {
                src: base64,
                alt: image.altText || "Image from Word document",
                "data-temp-key": imageKey, // Đánh dấu để upload sau
                class: "mx-auto",
              };
            } catch (error) {
              console.error("Error processing image for validation:", error);
              return {
                src: "",
                alt: "Error loading image",
              };
            }
          }),
          // Transform cho các element đặc biệt
          transformDocument: mammoth.transforms.paragraph(function (element) {
            // Xử lý bullet points và numbering
            if (element.numbering) {
              // Nếu là numbered list
              if (element.numbering.level !== undefined) {
                return {
                  ...element,
                  styleId: "numbered-list",
                  styleName: "Numbered List",
                };
              } else {
                // Bullet list
                return {
                  ...element,
                  styleId: "bullet-list",
                  styleName: "Bullet List",
                };
              }
            }

            return element;
          }),
        }
      );

      console.log("Total images uploaded:", uploadedImages.size);

      // Post-process HTML để wrap li elements trong ul
      let processedHtmlContent = result.value;

      // Clean up và format lists
      const cleanupLists = (html) => {
        // Remove br tags ở đầu và cuối content
        html = html.replace(/^(\s*<br\s*\/?>)+/gi, "");
        html = html.replace(/(\s*<br\s*\/?>)+$/gi, "");

        // Remove multiple consecutive br tags
        html = html.replace(/(<br\s*\/?>){2,}/gi, "<br/>");

        // Wrap consecutive li elements trong ul tags
        html = html.replace(
          /(<li[^>]*>.*?<\/li>)(\s*<li[^>]*>.*?<\/li>)*/g,
          function (match) {
            return "<ul>" + match + "</ul>";
          }
        );

        // Remove nested ul trong ul (nếu có)
        html = html.replace(/<ul>\s*<ul>/g, "<ul>");
        html = html.replace(/<\/ul>\s*<\/ul>/g, "</ul>");

        // Đảm bảo li elements có content
        html = html.replace(/<li[^>]*>\s*<\/li>/g, "");

        // Remove br tags ngay sau opening tags và trước closing tags
        html = html.replace(/(<[^\/][^>]*>)\s*<br\s*\/?>/gi, "$1");
        html = html.replace(/<br\s*\/?>\s*(<\/[^>]+>)/gi, "$1");

        return html;
      };

      processedHtmlContent = cleanupLists(processedHtmlContent);

      const htmlContent = processedHtmlContent;
      console.log("HTML content from docx:", htmlContent);

      // Parse HTML để tách câu hỏi
      const parser = new DOMParser();
      const doc = parser.parseFromString(htmlContent, "text/html");

      // Lấy tất cả text nodes và elements
      const allContent = doc.body.innerHTML;

      // Debug: log raw HTML content
      console.log("Raw HTML from mammoth:", allContent);

      // Tách thành các dòng, giữ nguyên HTML tags và loại bỏ dòng trống
      const lines = allContent
        .split(/<\/p>|<br\s*\/?>/)
        .map((line) =>
          line
            .replace(/<p[^>]*>/g, "")
            .replaceAll("&nbsp;", " ")
            .replaceAll("&lt;", "<")
            .replaceAll("&gt;", ">")
            .replaceAll("&amp;", "&")
            .trim()
        )
        .map((line) => {
          if (
            isLineQuestionAnswer(line) ||
            isLineAnswerTN(line) ||
            isLineAnswerDS(line) ||
            isLineAnswerMA(line) ||
            isLineQuestionMQ(line)
          ) {
            return removeHTMLTags(line);
          }
          return line;
        })
        .filter((line) => line && line !== "" && line.length > 0); // Xóa dòng trống

      console.log("Parsed lines after filtering:", lines);

      let questionsArray = [];
      let currentQuestion = null;
      let currentQuestionMQ = null;

      // Helper function để clean content
      const cleanContent = (content) => {
        if (!content) return content;

        // Remove br tags ở đầu và cuối
        content = content.replace(/^(\s*<br\s*\/?>)+/gi, "");
        content = content.replace(/(\s*<br\s*\/?>)+$/gi, "");

        // Replace multiple consecutive br tags
        content = content.replace(/(<br\s*\/?>){3,}/gi, "<br/><br/>");

        return content.trim();
      };

      // Global counter cho fill-in-the-blank cho mỗi câu hỏi
      let globalBlankIndex = 0;

      // Helper function để xử lý chỗ điền đáp án (____)
      const processFillInTheBlanks = (content, questionNumber) => {
        if (!content) return content;

        // Detect và thay thế các ký hiệu ____ bằng placeholder đặc biệt
        // Sử dụng regex để tìm các chuỗi gạch dưới liên tiếp (4 hoặc nhiều hơn)
        const blankPattern = /_{4,}/g;

        const processedContent = content.replace(blankPattern, (match) => {
          globalBlankIndex++; // Sử dụng global counter
          // Tạo placeholder với ID duy nhất để sau này có thể thay thế bằng input field
          return `<span class="fill-blank" data-blank-id="${questionNumber}-${globalBlankIndex}" data-blank-length="${match.length}">____FILL_BLANK_${globalBlankIndex}____</span>`;
        });

        return processedContent;
      };

      // Helper function để xử lý chỗ kéo thả (<KT/>)
      const processDragDropBlanks = (content, questionNumber) => {
        if (!content) return content;

        // Detect và thay thế các ký hiệu <KT/> bằng placeholder đặc biệt
        const dragDropPattern = /<KT\/?>|&lt;KT\/?&gt;/gi; // Thêm flag 'i' để case-insensitive

        const processedContent = content.replace(dragDropPattern, (match) => {
          globalBlankIndex++; // Sử dụng global counter
          // Tạo placeholder với ID duy nhất để sau này có thể thay thế bằng drag-drop zone
          return `<span class="drag-drop-blank" data-drop-id="${questionNumber}-${globalBlankIndex}">____DRAG_DROP_${globalBlankIndex}____</span>`;
        });

        return processedContent;
      };

      for (let i = 0; i < lines.length; i++) {
        let line = lines[i].trim() || "";
        // // Skip empty lines
        if (!line || line.length === 0) continue;

        // Kiểm tra nếu là câu hỏi mới (bắt đầu bằng số như "Câu 1:", "Câu 1.",  "Câu hỏi 1:", "Câu hỏi 1." etc.)
        const questionMatch = regexQuestionAnswer(line);
        console.log(
          "🚀 ~ processQuestionsFromDocxMath ~ line:",
          line,
          isLineAnswerMQStartWith(line)
        );
        if (questionMatch) {
          // Lưu câu hỏi trước đó nếu có
          if (currentQuestion) {
            questionsArray.push(currentQuestion);
          }

          if (currentQuestionMQ && currentQuestionMQ?.contentQuestions) {
            questionsArray.push(currentQuestionMQ);
            currentQuestionMQ = null;
          }

          // Reset global blank index cho câu hỏi mới
          globalBlankIndex = 0;

          const questionNumber = questionMatch[1];
          const questionContent = questionMatch[2];

          let processedContent = cleanContent(questionContent);
          // Xử lý fill-in-the-blank trước
          processedContent = processFillInTheBlanks(
            processedContent,
            questionNumber
          );
          // Sau đó xử lý drag-drop
          processedContent = processDragDropBlanks(
            processedContent,
            questionNumber
          );

          currentQuestion = {
            question: questionNumber,
            contentQuestions: processedContent,
            type: "TN", // Mặc định là trắc nghiệm
            correctAnswer: "",
            explanation: "",
          };

          // Đọc tiếp để lấy phần còn lại của câu hỏi (cho đến khi gặp đáp án)
          for (let j = i + 1; j < lines.length; j++) {
            let nextLine = lines[j].trim() || "";

            // Nếu gặp đáp án A, B, C, D thì dừng
            if (
              isLineAnswerTNStartWith(nextLine) ||
              isLineAnswerDSStartWith(nextLine) ||
              isLineAnswerMAStartWith(nextLine)
            ) {
              break;
            }

            // // Nếu gặp đáp án thì dừng
            if (isLineQuestionAnswerStartWith(nextLine)) {
              break;
            }

            // Nếu gặp câu hỏi tiếp theo thì dừng
            if (regexQuestionAnswer(nextLine)) {
              break;
            }

            // Thêm vào nội dung câu hỏi nếu không phải dòng trống
            if (nextLine && nextLine.length > 0 && !isLineAnswerKT(nextLine)) {
              let processedNextLine = processFillInTheBlanks(
                nextLine,
                questionNumber
              );
              processedNextLine = processDragDropBlanks(
                processedNextLine,
                questionNumber
              );
              currentQuestion.contentQuestions += "<br/>" + processedNextLine;
            }
          }
        }
        // Câu hỏi trắc nghiệm
        else if (isLineAnswerTNStartWith(line) && currentQuestion) {
          let lineArr = line.split(/(?=[ABCD]\.\s?)/);
          getAllAnswerTN(lines, lineArr, i, currentQuestion);
        }
        // Câu hỏi đúng sai
        else if (isLineAnswerDSStartWith(line) && currentQuestion) {
          getAllAnswerDS(lines, line, i, currentQuestion);
        }
        // Câu hỏi nhiều đáp án
        else if (isLineAnswerMAStartWith(line) && currentQuestion) {
          getAllAnswerMA(lines, line, i, currentQuestion);
        }
        // Câu hỏi kéo thả
        else if (
          isLineAnswerKT(line) &&
          !line.startsWith("Đáp án TLN_M") &&
          currentQuestion
        ) {
          currentQuestion.items = line
            .split("@")
            .map((t) => t.trim())
            .map((t, index) => {
              const answer = {};
              if (index === 0) {
                answer.id = "A>";
                answer.content = t;
              }
              if (index === 1) {
                answer.id = "B>";
                answer.content = t;
              }
              if (index === 2) {
                answer.id = "C>";
                answer.content = t;
              }
              if (index === 3) {
                answer.id = "D>";
                answer.content = t;
              }
              if (index === 4) {
                answer.id = "E>";
                answer.content = t;
              }
              if (index === 5) {
                answer.id = "F>";
                answer.content = t;
              }
              if (index === 6) {
                answer.id = "G>";
                answer.content = t;
              }
              if (index === 6) {
                answer.id = "H>";
                answer.content = t;
              }
              if (index === 7) {
                answer.id = "I>";
                answer.content = t;
              }
              if (index === 8) {
                answer.id = "J>";
                answer.content = t;
              }
              return answer;
            });
        }
        // Câu hỏi nhiều câu hỏi con (MQ)
        else if (isLineAnswerMQStartWith(line)) {
          const title = line?.startsWith("MQ: ")
            ? line.substring(3)
            : line.substring(2);
          currentQuestionMQ = {
            question: uuidv4(),
            contentQuestions: "",
            title,
            range: extractQuestionRange(title),
            type: "MQ",
          };

          for (let j = i + 1; j < lines.length; j++) {
            let nextLine = lines[j].trim() || "";

            // Nếu gặp đáp án A, B, C, D thì dừng
            if (
              isLineAnswerTNStartWith(nextLine) ||
              isLineAnswerDSStartWith(nextLine) ||
              isLineAnswerMAStartWith(nextLine)
            ) {
              break;
            }

            // // Nếu gặp đáp án thì dừng
            if (isLineQuestionAnswerStartWith(nextLine)) {
              break;
            }

            // Nếu gặp câu hỏi tiếp theo thì dừng
            if (regexQuestionAnswer(nextLine)) {
              break;
            }

            if (nextLine && nextLine.length > 0 && !isLineAnswerKT(nextLine)) {
              currentQuestionMQ.contentQuestions += "<br/>" + nextLine;
            }
          }
        }
        // Đáp án TN
        else if (line.startsWith("Đáp án TN") && currentQuestion) {
          currentQuestion.type = "TN";
          currentQuestion.correctAnswer = line.split("Đáp án TN:")[1]?.trim();
        }
        // Đáp án DS
        else if (line.startsWith("Đáp án DS") && currentQuestion) {
          currentQuestion.type = "DS";

          const correctAnswer = {};
          line
            .split("Đáp án DS:")[1]
            ?.split("|")
            ?.map((t, index) => {
              const answer = {};
              if (index === 0) {
                correctAnswer.a = t.trim();
              }
              if (index === 1) {
                correctAnswer.b = t.trim();
              }
              if (index === 2) {
                correctAnswer.c = t.trim();
              }
              if (index === 3) {
                correctAnswer.d = t.trim();
              }
              return answer;
            });
          currentQuestion.correctAnswer = correctAnswer;
        }
        // Đáp án MA
        else if (line.startsWith("Đáp án MA") && currentQuestion) {
          currentQuestion.type = "MA";
          currentQuestion.correctAnswer = line
            .split("Đáp án MA:")[1]
            ?.split("|")
            .map((t) => t.trim());
        }
        // Đáp án TLN
        else if (
          line.startsWith("Đáp án TLN") &&
          !line.startsWith("Đáp án TLN_M") &&
          currentQuestion
        ) {
          currentQuestion.type = "TLN";
          let lineTLN = line.split("Đáp án TLN:")[1];
          lineTLN = lineTLN.trim();
          if (lineTLN.includes("|")) {
            currentQuestion.correctAnswer = lineTLN
              .split("|")
              .map((t) => t.trim())
              .map((t) => (isNumeric(t) ? parseFloat(t) : t));
          } else {
            currentQuestion.correctAnswer = isNumeric(lineTLN)
              ? [parseFloat(lineTLN)]
              : [lineTLN];
          }
        }

        // Đáp án TLN_M
        else if (line.startsWith("Đáp án TLN_M") && currentQuestion) {
          currentQuestion.type = "TLN_M";

          const correctAnswer = {};
          line
            .split("Đáp án TLN_M:")[1]
            ?.split("|")
            // ?.map((t) => (isNumeric(t) ? parseFloat(t) : t))
            ?.map((t, index) => {
              t = t.split("@") && t.split("@").length > 0 ? t.split("@") : t;
              t =
                Array.isArray(t) &&
                t.map((t) => (isNumeric(t) ? parseFloat(t) : t.trim()));
              const answer = {};
              if (index === 0) {
                correctAnswer["1."] = t;
              }
              if (index === 1) {
                correctAnswer["2."] = t;
              }
              if (index === 2) {
                correctAnswer["3."] = t;
              }
              if (index === 3) {
                correctAnswer["4."] = t;
              }
              if (index === 4) {
                correctAnswer["5."] = t;
              }
              if (index === 5) {
                correctAnswer["6."] = t;
              }
              return answer;
            });

          currentQuestion.correctAnswer = correctAnswer;
        }

        // Đáp án KT
        else if (line.startsWith("Đáp án KT") && currentQuestion) {
          currentQuestion.type = "KT";
          const correctAnswer = {};
          line
            .split("Đáp án KT:")[1]
            ?.split("|")
            ?.map((t, index) => {
              const answer = {};
              if (index === 0) {
                correctAnswer.slot1 = t.replace("&gt;", ">").trim();
              }
              if (index === 1) {
                correctAnswer.slot2 = t.replace("&gt;", ">").trim();
              }
              if (index === 2) {
                correctAnswer.slot3 = t.replace("&gt;", ">").trim();
              }
              if (index === 3) {
                correctAnswer.slot4 = t.replace("&gt;", ">").trim();
              }
              if (index === 4) {
                correctAnswer.slot5 = t.replace("&gt;", ">").trim();
              }
              if (index === 5) {
                correctAnswer.slot6 = t.replace("&gt;", ">").trim();
              }
              return answer;
            });
          currentQuestion.correctAnswer = correctAnswer;
        }

        // Kiểm tra nếu là Explanation
        else if (line.startsWith("Lời giải:") && currentQuestion) {
          // Trường hợp 1: Explanation cùng dòng
          const explanationMatch = line.split("Lời giải:")[1] || "";
          currentQuestion.explanation = cleanContent(explanationMatch.trim());

          // Tiếp tục đọc các dòng tiếp theo để lấy phần explanation còn lại
          for (let j = i + 1; j < lines.length; j++) {
            const nextLine = lines[j].trim();

            // Nếu gặp đáp án A, B, C, D thì dừng
            if (
              isLineAnswerTNStartWith(nextLine) ||
              isLineAnswerDSStartWith(nextLine) ||
              isLineAnswerMAStartWith(nextLine)
            ) {
              break;
            }

            // // Nếu gặp đáp án thì dừng
            if (isLineQuestionAnswerStartWith(nextLine)) {
              break;
            }

            // Nếu gặp câu hỏi tiếp theo thì dừng
            if (regexQuestionAnswer(nextLine)) {
              break;
            }

            // Nếu có nội dung explanation tiếp theo
            if (nextLine && nextLine.length > 0) {
              currentQuestion.explanation += "<br/>" + cleanContent(nextLine);
            }
          }
        }
      }

      // Thêm câu hỏi cuối cùng
      if (currentQuestion) {
        questionsArray.push(currentQuestion);
      }

      // Tự động tạo answer object từ các đáp án đúng đã được detect
      const autoAnswer = {};
      questionsArray.forEach((q, index) => {
        if (q.correctAnswer) {
          autoAnswer[q.question] = q.correctAnswer;
        } else {
          // Nếu không detect được đáp án đúng, mặc định là A
          autoAnswer[q.question] = "X";
          // toast.error("Không tìm thấy đáp án đúng cho câu hỏi: " + q.question);
        }
      });

      console.log("Auto-generated answer object:", autoAnswer);

      // Cập nhật answer state với dữ liệu tự động tạo
      setAnswer(autoAnswer);
      localStorage.setItem("answers", JSON.stringify(autoAnswer));
      setFormData({ ...formQuestionData, answer: autoAnswer });

      const detectedAnswers = Object.keys(autoAnswer).filter(
        (key) => autoAnswer[key] !== "X"
      ).length;

      const successMessage =
        uploadedImages.size > 0
          ? `Nhập câu hỏi từ file Word thành công! Đã detect ${detectedAnswers} đáp án đúng và upload ${uploadedImages.size} ảnh.`
          : `Nhập câu hỏi từ file Word thành công! Đã detect ${detectedAnswers} đáp án đúng tự động.`;

      // Log explanation statistics
      const questionsWithExplanation = questionsArray.filter(
        (q) => q.explanation && q.explanation.trim().length > 0
      );
      console.log(
        `📝 Found ${questionsWithExplanation.length} questions with explanations`
      );
      questionsWithExplanation.forEach((q) => {
        console.log(`✅ ${q.question}: ${q.explanation.substring(0, 100)}...`);
      });
      console.log("✅ QuestionsArray:", questionsArray);
      console.log("✅ Answer:", answer);

      // Validate questionsArray trước khi return
      const isValid = validateQuestionsArray(questionsArray);
      if (!isValid) {
        console.log("❌ Validation failed for questions from .docx file");
        setFormData({ ...formQuestionData, questions: questionsArray });
        return questionsArray; // Return empty array nếu validation fail
      }

      toast.success(successMessage);
      setFormData({
        ...formQuestionData,
        questions: questionsArray,
      });
      return questionsArray;
    } catch (error) {
      console.error("Error processing docx file:", error);
      toast.error("Lỗi khi xử lý file Word: " + error.message);
      return [];
    }
  }

  // Function validate questionsArray
  const validateQuestionsArray = (questionsArray) => {
    const errors = [];
    questionsArray.forEach((q, index) => {
      // Chỉ validate cho câu hỏi trắc nghiệm (type = "TN")
      if (q.type === "TN") {
        let requiredFields = [
          "question",
          "contentQuestions",
          "type",
          "contentAnswerA",
          "contentAnswerB",
          "correctAnswer",
        ];
        requiredFields.forEach((field) => {
          const value = q[field];

          // Kiểm tra nếu field bị rỗng hoặc chỉ chứa whitespace
          if (!value || (typeof value === "string" && value.trim() === "")) {
            const fieldName = {
              question: "Câu hỏi",
              contentQuestions: "Nội dung câu hỏi",
              type: "Loại câu hỏi",
              contentAnswerA: "Đáp án A",
              contentAnswerB: "Đáp án B",
              correctAnswer: "Đáp án đúng",
            }[field];

            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu ${fieldName}`
            );
          }
        });
      } else if (q.type === "DS") {
        let requiredFields = [
          "question",
          "contentQuestions",
          "type",
          "contentYA",
          "contentYB",
          "correctAnswer",
        ];
        requiredFields.forEach((field) => {
          const value = q[field];

          // Kiểm tra nếu field bị rỗng hoặc chỉ chứa whitespace
          if (!value || (typeof value === "string" && value.trim() === "")) {
            const fieldName = {
              question: "Câu hỏi",
              contentQuestions: "Nội dung câu hỏi",
              type: "Loại câu hỏi",
              contentYA: "Mệnh đề a)",
              contentYB: "Mệnh đề b)",
              correctAnswer: "Đáp án đúng",
            }[field];

            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại Loại ${
                q.type
              } - Thiếu ${fieldName}`
            );
          } else if (
            field === "correctAnswer" &&
            Array.isArray(value) &&
            value.length === 0
          ) {
            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu đáp án đúng`
            );
          }
        });
      } else if (q.type === "MA") {
        let requiredFields = [
          "question",
          "contentQuestions",
          "type",
          "contentC1",
          "contentC2",
          "correctAnswer",
        ];

        requiredFields.forEach((field) => {
          const value = q[field];

          // Kiểm tra nếu field bị rỗng hoặc chỉ chứa whitespace
          if (!value || (typeof value === "string" && value.trim() === "")) {
            const fieldName = {
              question: "Câu hỏi",
              contentQuestions: "Nội dung câu hỏi",
              type: "Loại câu hỏi",
              contentC1: "Nội dung ý 1",
              contentC2: "Nội dung ý 2",
              correctAnswer: "Đáp án đúng",
            }[field];

            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              }- Thiếu ${fieldName}`
            );
          } else if (
            field === "correctAnswer" &&
            Array.isArray(value) &&
            value.length === 0
          ) {
            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu đáp án đúng`
            );
          }
        });
      } else if (q.type === "KT") {
        let requiredFields = [
          "question",
          "contentQuestions",
          "type",
          "correctAnswer",
          "items",
        ];
        requiredFields.forEach((field) => {
          const value = q[field];

          // Kiểm tra nếu field bị rỗng hoặc chỉ chứa whitespace
          if (!value || (typeof value === "string" && value.trim() === "")) {
            const fieldName = {
              question: "Câu hỏi",
              contentQuestions: "Nội dung câu hỏi",
              type: "Loại câu hỏi",
              contentC1: "Nội dung ý 1",
              contentC2: "Nội dung ý 2",
              correctAnswer: "Đáp án đúng",
            }[field];

            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu ${fieldName}`
            );
          } else if (
            field === "correctAnswer" &&
            Array.isArray(value) &&
            value.length === 0
          ) {
            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu đáp án đúng`
            );
          }
        });
      } else if (q.type === "TLN") {
        // Với các loại câu hỏi khác, chỉ validate các trường cơ bản
        const basicFields = [
          "question",
          "contentQuestions",
          "type",
          "correctAnswer",
        ];
        basicFields.forEach((field) => {
          const value = q[field];
          if (!value || (typeof value === "string" && value.trim() === "")) {
            const fieldName = {
              question: "Câu hỏi",
              contentQuestions: "Nội dung câu hỏi",
              type: "Loại câu hỏi",
            }[field];

            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu ${fieldName}`
            );
          } else if (
            field === "correctAnswer" &&
            Array.isArray(value) &&
            value.length === 0
          ) {
            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu đáp án đúng`
            );
          }
        });
      } else if (q.type === "MQ") {
        // Với các loại câu hỏi khác, chỉ validate các trường cơ bản
        const basicFields = [
          "question",
          "title",
          "range",
          "contentQuestions",
          "type",
        ];
        basicFields.forEach((field) => {
          const value = q[field];
          if (!value || (typeof value === "string" && value.trim() === "")) {
            const fieldName = {
              question: "Câu hỏi",
              title: "Tiêu đề",
              range: "Tập hợp câu hỏi con",
              contentQuestions: "Nội dung câu hỏi",
              type: "Loại câu hỏi",
            }[field];

            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu ${fieldName}`
            );
          } else if (
            field === "correctAnswer" &&
            Array.isArray(value) &&
            value.length === 0
          ) {
            errors.push(
              `${q.question || `Câu ${index + 1}`}: Loại ${
                q.type
              } - Thiếu đáp án đúng`
            );
          }
        });
      }
    });

    // Hiển thị errors
    if (errors.length > 0) {
      errors.forEach((error) => {
        toast.error(error, {
          autoClose: 5000,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      });

      console.log("❌ Validation errors:", errors);
      return false;
    }

    console.log("✅ All questions validated successfully");
    return true;
  };

  const handleEditExam = (exam) => {
    setIsEditing(true);
    setFormData({
      ...exam,
      title: exam?.title,
      startTime: dayjs(exam?.startTime),
      endTime: dayjs(exam?.endTime),
    });
    setAnswer(exam?.answer);
    setQuestion(exam?.questions[0]);
    const keys = exam?.questions?.map((e) => e.question) || [];
    setListKeys(keys);
    setQuestionsData(exam?.questions);
  };

  const handleChangeContentQuestions = (event) => {
    const { name, value } = event.target;
    setQuestion({
      ...question,
      [name]: value,
    });
    const ques = questionsData.find((e) => e.question === question.question);
    if (ques) {
      if (name === "contentQuestions") {
        ques.contentQuestions = value;
      } else if (name === "explanation") {
        ques.explanation = value;
      }
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const res = await activeExam(id);
      toast.success(res.message);
      setListExams(
        listExams.map((exam) =>
          exam?._id === id
            ? {
                ...exam,
                isActive: !exam.isActive,
              }
            : exam
        )
      );
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  const handleChangeInputQuestion = (event) => {
    let { name, value } = event.target;
    // Handle boolean values (for Switch/Checkbox)
    if (typeof value === "boolean") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
      return;
    }
    if (name === "numberOfQuestions" || name === "time") {
      const roundedValue = Math.round(parseFloat(value));
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: isNaN(roundedValue) ? "" : roundedValue,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }

    if (value) {
      setErrors({
        ...errors,
        [name]: false,
      });
    }
  };

  const handleChangeDateStartTime = (date) => {
    setFormData({
      ...formQuestionData,
      startTime: date,
    });
  };

  const handleChangeDateEndTime = (date) => {
    setFormData({
      ...formQuestionData,
      endTime: date,
    });
  };

  const handleInsertExam = async () => {
    if (!validateForm()) {
      return;
    }

    const body = {
      ...formQuestionData,
      title: formQuestionData.title,
      answer,
      numberOfQuestions: parseInt(formQuestionData.numberOfQuestions),
      time: parseInt(formQuestionData.time),
      questions: questionsData,
    };

    try {
      const res = await insertOrUpdateExam(body);
      if (res && res.data) {
        setListExams([
          res.data,
          ...listExams.filter((e) => e?._id !== res.data?._id),
        ]);
        handleFetch();
        toast.success(res.message);
        setFormData({
          title: "",
          url: "",
          numberOfQuestions: null,
          time: null,
          startTime: dayjs(new Date()),
          endTime: dayjs(new Date()),
          subject: "TƯ DUY TOÁN HỌC",
          type: "TSA",
          imgUrl: "",
          access: "PRIVATE",
          isAnswer: false,
        });
        setDataInputQuestion("", []);
        setQuestionsData([]);
        setAnswer({});
        setQuestion({
          question: "Câu 1",
          contentQuestions: "",
          imageUrl: "",
          explanation: "",
          type: "",
        });
        setIsEditing(false);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const json = JSON.parse(e.target.result);
          setAnswer(json);
          toast.success("Upload file đáp án thành công");
        } catch (error) {
          console.error("Error parsing JSON:", error);
        } finally {
          refs.inputRef.current.value = null;
        }
      };

      reader.onerror = (e) => {
        console.error("File could not be read:", e.target.error);
        refs.inputRef.current.value = null;
      };

      reader.readAsText(file);
    }
  };

  const validateForm = () => {
    if (!formQuestionData.title) {
      toast.error("Vui lòng nhập tên đề thi");
      return false;
    }

    if (!formQuestionData.type) {
      toast.error("Vui lòng nhập kì thi");
      return false;
    }

    if (!formQuestionData.numberOfQuestions) {
      toast.error("Vui lòng nhập số câu hỏi");
      return false;
    }

    if (!formQuestionData.time) {
      toast.error("Vui lòng nhập thời gian thi");
      return false;
    }

    if (!formQuestionData.subject) {
      toast.error("Vui lòng chọn môn học");
      return false;
    }

    if (Object.keys(answer || {}).length === 0) {
      toast.error("Vui lòng uplpad file đáp án");
      return false;
    }
    return true;
  };

  const handleUpdateExam = async () => {
    const body = {
      ...formQuestionData,
      title: formQuestionData.title,
      answer,
      numberOfQuestions: parseInt(formQuestionData.numberOfQuestions),
      time: parseInt(formQuestionData.time),
      questions: questionsData,
    };

    try {
      const res = await insertOrUpdateExam(body);
      if (res && res.data) {
        setListExams(
          listExams.map((e) => (e._id === res.data?._id ? res.data : e))
        );
        handleFetch();
        toast.success(res.message);
        setFormData({
          title: "",
          url: "",
          numberOfQuestions: null,
          time: null,
          startTime: dayjs(new Date()),
          endTime: dayjs(new Date()),
          subject: "TƯ DUY TOÁN HỌC",
          type: "TSA",
          imgUrl: "",
          access: "PRIVATE",
          isAnswer: false,
        });
        setDataInputQuestion("", []);
        setQuestionsData([]);
        setAnswer({});
        setQuestion({
          question: "Câu 1",
          contentQuestions: "",
          imageUrl: "",
          explanation: "",
          type: "",
        });
        setIsEditing(false);
      }
    } catch (error) {
      const message = error?.response?.data?.message;
      toast.error(message);
    }
  };

  const handleChangeUploadFileQuestions = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        let data = [];

        if (file.name.endsWith(".docx")) {
          data = await processQuestionsFromDocx(file);
        } else {
          toast.error("Chỉ hỗ trợ file .docx");
          refs.inputRefQuestion.current.value = null;
          return;
        }

        if (data.length > 0) {
          const keys = data.map((e) => e.question);
          setListKeys(keys);
          setQuestionsData(
            data.map((item, index) => ({
              ...item,
              imageUrl: questionsData[index]?.imageUrl,
            }))
          );
          setDataInputQuestion(keys[0], data);
        }
      } catch (error) {
        console.error("Error processing file:", error);
        toast.dismiss("processing");
        toast.dismiss("uploading");
        toast.error("Lỗi khi xử lý file: " + error.message);
      }

      refs.inputRefQuestion.current.value = null;
    }
  };

  const handleChangeSelectQuestions = (event) => {
    const { name, value } = event.target;
    setDataInputQuestion(value, questionsData);
  };

  const handleChangeInputAnswer = (event) => {
    let { name, value } = event.target;
    if (
      question?.type === "KT" &&
      ["A>", "B>", "C>", "D>", "E>", "F>", "G>", "H>"].includes(name)
    ) {
      const newItems = question?.items.map((item, i) => {
        if (item.id === name) {
          return { id: name, content: value };
        }
        return { ...item };
      });
      setQuestion({
        ...question,
        items: newItems,
      });
      // Cập nhật vào questionsData
      const ques = questionsData.find((e) => e.question === question.question);
      if (ques) {
        ques.items = newItems;
      }
    } else {
      setQuestion({
        ...question,
        [name]: value,
      });
      // Cập nhật vào questionsData cho các trường contentAnswerA, B, C, D và các trường khác
      const ques = questionsData.find((e) => e.question === question.question);
      if (ques) {
        ques[name] = value;
      }
    }
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearch = () => {
    if (searchQuery) {
      setIsSearch(true);
    } else {
      setIsSearch(false);
    }
    setCurrentPage(1);
    handleFetch();
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      if (searchQuery) {
        setIsSearch(true);
      } else {
        setIsSearch(false);
      }
      handleSearch();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 overflow-y-auto pb-20">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-8 text-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center backdrop-blur-sm">
                <svg
                  className="w-8 h-8"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
              </div>
              <div>
                <h1 className="text-4xl font-bold mb-2">Quản Lý Đề Thi Thử</h1>
                <p className="text-blue-100 text-lg">
                  Quản lý và tạo đề thi thử cho hệ thống
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="bg-white/20 rounded-xl px-4 py-2 backdrop-blur-sm">
                <span className="text-sm font-medium">
                  Tổng đề thi: {listExams.length}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {/* Exam Form */}
        <ExamForm
          formQuestionData={formQuestionData}
          questionsData={questionsData}
          errors={errors}
          handleChangeInputQuestion={handleChangeInputQuestion}
          listKeys={listKeys}
          question={question}
          handleChangeSelectQuestions={handleChangeSelectQuestions}
          refs={refs}
          handleChangeUploadFileQuestions={handleChangeUploadFileQuestions}
          handleChangeContentQuestions={handleChangeContentQuestions}
          handleChangeInputAnswer={handleChangeInputAnswer}
          setOpenDialogQuestion={setOpenDialogQuestion}
          openDialogQuestion={openDialogQuestion}
          setOpenDialogExam={setOpenDialogExam}
          openDialogExam={openDialogExam}
          upLoadImageQuestions={upLoadImageQuestions}
          handleChangeDateStartTime={handleChangeDateStartTime}
          handleChangeDateEndTime={handleChangeDateEndTime}
          handleFileUpload={handleFileUpload}
          handleInsertExam={handleInsertExam}
          handleUpdateExam={handleUpdateExam}
          upLoadImageExam={upLoadImageExam}
          isEditing={isEditing}
          answer={answer}
          setAnswer={setAnswer}
        />

        {/* Search and Filter Section */}
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-6 shadow-xl border border-white/20 mb-8">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="flex items-center space-x-4 flex-1">
              <div className="relative flex-1 max-w-md">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Search className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  type="text"
                  placeholder="Tìm kiếm đề thi..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  onKeyPress={handleKeyPress}
                  className="block w-full pl-10 pr-3 py-3 border border-gray-200 rounded-xl bg-white/50 backdrop-blur-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                />
              </div>
              <button
                onClick={handleSearch}
                className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-semibold hover:from-blue-600 hover:to-purple-700 transition-all duration-200 transform hover:scale-105 shadow-lg"
              >
                Tìm kiếm
              </button>
            </div>
            {/* 
            <div className="flex items-center space-x-3">
              <button className="flex items-center space-x-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-xl hover:bg-gray-200 transition-all duration-200">
                <Filter className="h-4 w-4" />
                <span className="text-sm font-medium">Lọc</span>
              </button>
              <button className="flex items-center space-x-2 px-4 py-2 bg-green-100 text-green-700 rounded-xl hover:bg-green-200 transition-all duration-200">
                <Download className="h-4 w-4" />
                <span className="text-sm font-medium">Xuất Excel</span>
              </button>
            </div> */}
          </div>
        </div>

        {/* Exam Table */}
        <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl border border-white/20 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gradient-to-r from-gray-50 to-gray-100">
                <tr>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    No
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Tên đề thi
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Loại
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Môn học
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Thời gian
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Truy cập
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Trạng thái
                  </th>
                  <th className="px-6 py-4 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider">
                    Hành động
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {listExams.length > 0 ? (
                  listExams.map((exam, index) => (
                    <tr
                      key={exam?._id}
                      className="hover:bg-gray-50 transition-colors duration-200"
                    >
                      <td className="px-6 py-4 whitespace-nowrap">
                        <Tooltip title={exam?._id} placement="top">
                          <span className="text-sm font-medium text-gray-900 bg-gray-100 px-2 py-1 rounded-lg">
                            {exam?._id?.slice(0, 5)}...{exam?._id?.slice(-5)}
                          </span>
                        </Tooltip>
                      </td>
                      <td className="px-6 py-4">
                        <div className="text-sm font-semibold text-gray-900">
                          {exam?.title}
                        </div>
                      </td>
                      <td className="px-6 py-4">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                          {exam?.type}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-gray-900">
                          {exam?.subject}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span className="text-sm text-gray-900">
                          {exam?.time} phút
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            exam.access === "Miễn phí"
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {exam.access}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <span
                          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                            exam.isActive
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {exam.isActive ? "Đang mở" : "Chưa mở"}
                        </span>
                      </td>
                      <td className="px-6 py-4">
                        <div className="flex items-center justify-center space-x-2">
                          <Tooltip title="Chỉnh sửa" placement="top">
                            <button
                              onClick={() => handleEditExam(exam)}
                              className="p-2 text-indigo-600 hover:bg-indigo-50 rounded-lg transition-colors duration-200"
                            >
                              <Edit2 className="w-4 h-4" />
                            </button>
                          </Tooltip>
                          <Tooltip title="Xóa" placement="top">
                            <button
                              onClick={() =>
                                handleDeleteExam(exam?._id, exam?.title)
                              }
                              className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </Tooltip>
                          <Tooltip
                            title={exam?.isActive ? "Đang mở" : "Chưa mở"}
                            placement="top"
                          >
                            <button
                              onClick={() => handleToggleStatus(exam?._id)}
                              className={`p-2 rounded-lg transition-colors duration-200 ${
                                exam?.isActive === true
                                  ? "text-red-600 hover:bg-red-50"
                                  : "text-green-600 hover:bg-green-50"
                              }`}
                            >
                              {exam?.isActive === true ? (
                                <XCircle className="w-4 h-4" />
                              ) : (
                                <CheckCircle2 className="w-4 h-4" />
                              )}
                            </button>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="px-6 py-12 text-center">
                      <div className="flex flex-col items-center space-y-4">
                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center">
                          <svg
                            className="w-8 h-8 text-gray-400"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                            />
                          </svg>
                        </div>
                        <div>
                          <h3 className="text-lg font-semibold text-gray-900 mb-1">
                            Không có đề thi nào
                          </h3>
                          <p className="text-gray-500">
                            Hãy tạo đề thi đầu tiên để bắt đầu
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {listExams.length > 0 && (
            <div className="bg-gray-50 px-6 py-4 border-t border-gray-200">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <span className="text-sm text-gray-700">
                    Trang{" "}
                    {isSearch ? "1 / 1" : `${currentPage} / ${totalPages}`}
                  </span>
                  <span className="text-sm text-gray-500">
                    (Tổng {listExams.length} đề thi)
                  </span>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1 || isSearch}
                    className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    Trước
                  </button>
                  <button
                    onClick={() =>
                      setCurrentPage((p) => (p < totalPages ? p + 1 : p))
                    }
                    disabled={currentPage === totalPages || isSearch}
                    className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    Sau
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Delete Confirm Modal */}
      <DeleteConfirmModal
        isOpen={deleteModal.isOpen}
        onClose={() =>
          setDeleteModal({ isOpen: false, examId: null, examTitle: "" })
        }
        onConfirm={confirmDeleteExam}
        title="Xác nhận xóa đề thi"
        message="Bạn có chắc chắn muốn xóa đề thi này?"
        itemName={deleteModal.examTitle}
      />
    </div>
  );
}
